<template>
  <v-card
    flat
    :loading="load"
  >
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <!-- Questões principais -->
        <h3 class="mt-4 text-h6">
          Questões Psicossociais
        </h3>
        <v-row
          v-for="(question, index) in mainQuestions"
          :key="'main-' + index"
        >
          <v-col cols="12">
            <v-row align="center">
              <v-col
                cols="12"
                sm="8"
              >
                <div class="question-text">
                  {{ index + 1 }}. {{ question.text }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <v-radio-group
                  v-model="formData[question.field]"
                  inline
                  dense
                  class="mt-0"
                >
                  <v-radio
                    label="Não"
                    value="NAO"
                  />
                  <v-radio
                    label="Sim"
                    value="SIM"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider />
          </v-col>
        </v-row>

        <!-- Questões complementares -->
        <h3 class="mt-4 text-h6">
          Questões Complementares
        </h3>
        <v-row
          v-for="(question, index) in complementaryQuestions"
          :key="'comp-' + index"
        >
          <v-col cols="12">
            <v-row align="center">
              <v-col
                cols="12"
                sm="8"
              >
                <div class="question-text">
                  {{ question.text }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <v-radio-group
                  v-model="formData[question.field]"
                  inline
                  dense
                  class="mt-0"
                >
                  <v-radio
                    label="Não"
                    value="NAO"
                  />
                  <v-radio
                    label="Sim"
                    value="SIM"
                  />
                  <v-radio
                    label="Ignorado"
                    value="IGNORADO"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :loading="load"
        variant="text"
        color="red"
        @click="$emit('voltar', 'voltar')"
      >
        <v-icon start>
          mdi-keyboard-return
        </v-icon>
        Cancelar
      </v-btn>
      <v-btn
        color="secondary"
        :disabled="load"
        @click="reset"
      >
        Limpar
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!valid"
        :loading="load"
        @click="submit"
      >
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import medicoService from '../../services/medico.service';

export default {
    name: 'AnamneseExame2',
    props: {
        idExamesOS: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            valid: true,
            load: false,
            formData: this.getInitialFormData(),
            mainQuestions: [
                { text: 'Tem dores de cabeça frequentes?', field: 'dorCabecaFrequente' },
                { text: 'Tem falta de apetite?', field: 'faltaApetite' },
                { text: 'Dorme mal?', field: 'dormeMal' },
                { text: 'Assusta-se com facilidade?', field: 'assustaFacil' },
                { text: 'Tem tremores de mão?', field: 'tremoresMao' },
                { text: 'Sente-se nervoso(a), tenso(a) ou preocupado(a)?', field: 'senteNervoso' },
                { text: 'Tem má digestão?', field: 'maDigestao' },
                { text: 'Tem dificuldade de pensar com clareza?', field: 'dificuldadePensar' },
                { text: 'Tem se sentido triste ultimamente?', field: 'senteTriste' },
                { text: 'Tem chorado mais que de costume?', field: 'choroExcessivo' },
                { text: 'Tem dificuldade para realizar com satisfação suas atividades diárias?', field: 'dificuldadeAtividades' },
                { text: 'Tem dificuldades para tomar decisões?', field: 'dificuldadeDecisoes' },
                { text: 'Tem dificuldades no serviço (seu trabalho é penoso, causa sofrimento)?', field: 'dificuldadeServico' },
                { text: 'É incapaz de desempenhar um papel útil em sua vida?', field: 'incapazPapelUtil' },
                { text: 'Tem perdido o interesse pelas coisas?', field: 'perdaInteresse' },
                { text: 'Você se sente uma pessoa inútil, sem préstimo?', field: 'senteInutil' },
                { text: 'Você tem tido ideias de acabar com a vida?', field: 'ideiasSuicidas' },
                { text: 'Sente-se cansado(a) o tempo todo?', field: 'cansadoTodoTempo' },
                { text: 'Tem sensações desagradáveis no estômago?', field: 'sensacaoEstomago' },
                { text: 'Você se cansa com facilidade?', field: 'cansaFacil' }
            ],
            complementaryQuestions: [
                { text: 'Você tem medo de altura?', field: 'medoAltura' },
                { text: 'Você tem medo de espaços fechados?', field: 'medoEspacosFechados' },
                { text: 'Você tem ou já teve alguma dificuldade de equilíbrio?', field: 'dificuldadeEquilibrio' },
                { text: 'Você já teve convulsões?', field: 'teveConvulsoes' },
                { text: 'Você já desmaiou por algum motivo?', field: 'jaDesmaiou' }
            ]
        };
    },
    mounted() {
        if (this.idExamesOS) {
            this.buscarAvaliacaoPsicosocial();
        }
    },
    methods: {
        getInitialFormData() {
            return {
                id: null,
                data_registro: new Date().toISOString(),
                idExamesOs: null,
                dorCabecaFrequente: null, faltaApetite: null, dormeMal: null, assustaFacil: null, tremoresMao: null,
                senteNervoso: null, maDigestao: null, dificuldadePensar: null, senteTriste: null, choroExcessivo: null,
                dificuldadeAtividades: null, dificuldadeDecisoes: null, dificuldadeServico: null, incapazPapelUtil: null,
                perdaInteresse: null, senteInutil: null, ideiasSuicidas: null, cansadoTodoTempo: null, sensacaoEstomago: null,
                cansaFacil: null, medoAltura: null, medoEspacosFechados: null, dificuldadeEquilibrio: null, teveConvulsoes: null,
                jaDesmaiou: null
            };
        },
        async submit() {
            const { valid } = await this.$refs.form.validate();
            if (!valid) return;
            
            this.load = true;
            this.formData.idExamesOs = this.idExamesOS;
            medicoService.medico.cadastrarAvaliacaoPsicosocial(this.formData).then(response => {
                if (response.status === 200) {
                    this.$emit('voltar');
                }
            }).finally(() => {
                this.load = false;
            });
        },
        reset() {
            this.formData = this.getInitialFormData();
            this.$refs.form.resetValidation();
        },
        buscarAvaliacaoPsicosocial() {
            this.load = true;
            medicoService.medico.buscarAvaliacaoPsicosocial(this.idExamesOS).then(response => {
                if (response.status === 200 && response.data.success) {
                    this.formData = { ...this.formData, ...response.data.data };
                }
            }).finally(() => {
                this.load = false;
            });
        }
    }
}
</script>

<style scoped>
.question-text {
    font-size: 0.9rem;
    font-weight: 500;
}
.v-radio-group {
    margin-top: 0;
}
</style>
